import { HypeItErrorCodeType as ApiHypeItErrorCodeType } from 'src/api/generated/touring/types';
import { mapHypeItErrorModuleType } from './helpers';
import { HypeItErrorCodeType } from './types';

export const mapHypeItErrorCodeType = (
  apiType: ApiHypeItErrorCodeType | undefined
): HypeItErrorCodeType | null => {
  if (!apiType) return null;

  return {
    code: apiType.code,
    deprecated: apiType.deprecated,
    description: apiType.description ?? null,
    details: apiType.details ?? null,
    level: apiType.level,
    translations: apiType.translations,
    module: apiType.module ? mapHypeItErrorModuleType(apiType.module) : null,
    instructions: apiType.instructions ?? null,
    httpStatusCode: apiType.httpStatusCode ?? null,
    parameters: apiType.parameters ?? null,
  };
};
